import Bowser from 'bowser';
import { PopUpService } from '../service/PopUpService';

const BROWSER_MAP = {
  // chrome: 'Chrome',
  // firefox: 'Firefox',
  ie: 'Internet Explorer',
  safari: 'Safari',
};
const browser = Bowser.getParser(window.navigator.userAgent);
const browserName = browser.getBrowserName();

export const BROWSER_IS_SAFARI = browserName === BROWSER_MAP.safari;
export const BROWSER_IS_IE = browserName === BROWSER_MAP.ie;


export class PopUpBiz {
  static async init() {
    const settings = await PopUpBiz.fetchUserNotificationOption();
    const result = {
      notificationPermission: PopUpBiz.getNotification,
      settings,
    };
    return result;
  }

  static getNotification() {
    return window.Notification ? window.Notification.permission : 'default';
  }

  static async save(settings) {
    await PopUpService.saveUserNotificationOptions(settings);
  }

  static async fetchUserNotificationOption() {
    const settings = await PopUpService.fetchUserNotificationOptions();
    return settings;
  }
}
